import { getStorageItem } from 'services/localStorage';

/**
 * Download a PDF file from an authenticated URL.
 * Fetches the resource with Bearer Token authentication and opens it as a blob URL.
 *
 * @param url - The URL to fetch and open
 * @throws Error if the token is not available or if the fetch fails
 */
export async function pdfDownload(url: string): Promise<void> {
  const token = getStorageItem('token');

  if (!token) {
    throw new Error('Token de autenticação não encontrado');
  }

  if (!url) {
    throw new Error('URL não fornecida');
  }

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/pdf, application/json, */*',
      },
    });

    if (!response.ok) {
      throw new Error(
        `Erro ao baixar arquivo: ${response.status} ${response.statusText}`,
      );
    }

    const blob = await response.blob();

    const pdfBlob = new Blob([blob], { type: 'application/pdf' });
    const blobUrl = window.URL.createObjectURL(pdfBlob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'boleto.pdf';
    link.target = '_blank';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
    }, 1000);
  } catch (error) {
    console.error('Erro ao abrir URL autenticada:', error);
    throw error;
  }
}
